import 'reflect-metadata';
import React from 'react';
import ReactDOM from 'react-dom';
import { history, store } from './app/store'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'connected-react-router'
import { CssBaseline } from '@material-ui/core';
import i18n from './i18n';

import App from './App';

import reportWebVitals from './reportWebVitals';
import { AppThemeProvider } from './features/app-theme-provider/AppThemeProvider';
import { HashRouter } from 'react-router-dom';

/** Import preview mode css */
import "./preview.css";
import { I18nextProvider } from 'react-i18next';

ReactDOM.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <HashRouter>
            <AppThemeProvider>
              <CssBaseline />
              <App />
            </AppThemeProvider>
          </HashRouter>
        </ConnectedRouter>
      </Provider>
    </I18nextProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();